const LangSpainFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
    <rect width="16" height="3.66" fill="#AA151B" />
    <rect width="16" height="7.32" y="3.66" fill="#F1BF00" />
    {/* Adding Coat of Arms on the left side, simple placeholder for the sake of example */}
    <circle cx="1" cy="5.5" r="1" fill="#AA151B" />
  </svg>
);

export default LangSpainFlag;
